import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DateTime } from "luxon";
import { error } from "protractor";
import { map, tap } from "rxjs/operators";
import { ITimePeriod } from "./models/ITimePeriod";
import { CustomHttpParamsEncoder } from "src/app/shared/CustomHttpParamsEncoder";

const periodUrl = "/api/timeperiod";

@Injectable({
  providedIn: "root",
})
export class TimePeriodsService {
  constructor(private http: HttpClient) { }

  getTimePeriod(id: number) {
    return this.http.get<ITimePeriod>(`${periodUrl}/${id}`).pipe(
      map((timePeriod) => {
        timePeriod.date = DateTime.fromISO(timePeriod.dateISO);
        return timePeriod;
      })
    );
  }
  getTimePeriodsForYear(year: number) {
    const params = new HttpParams().set("year", year.toString());
    return this.http
      .get<ITimePeriod[]>(periodUrl, { params })
      .pipe(tap((p) => console.log("periods", p)));
  }
  getTimePeriodExceptions(from: DateTime, to: DateTime) {
    const params = new HttpParams({ encoder: new CustomHttpParamsEncoder() })
      .set("from", from.toISODate())
      .set("to", to.toISODate());

    return this.http
      .get<ITimePeriod[]>(`${periodUrl}/exceptions`, { params })
      .pipe(
        map((timePeriods) => {
          return timePeriods.map((period) => {
            period.date = DateTime.fromISO(period.dateISO);
            return period;
          });
        })
      );
  }
  createTimePeriod(month: number, year: number) {
    const date = DateTime.local().set({ month, year });
    return this.http.post<ITimePeriod>(periodUrl, { date: date.toISODate() });
  }
  lockPeriod(periodId: number) {
    return this.http.put<ITimePeriod>(`${periodUrl}/lock/${periodId}`, {});
  }
  unlockPeriod(periodId: number) {
    return this.http.put<ITimePeriod>(`${periodUrl}/unlock/${periodId}`, {});
  }
}
